import { gql } from 'urql';

const FeeBasedTransferExternalDebitCardsQuery = gql`
  query FeeBasedTransferExternalDebitCards {
    transferOptions(input: { includeExternalDebitCardDestinations: true }) {
      __typename
      ... on TransferOptions {
        destinationExternalDebitCards {
          __typename
          id
          isSelectable
        }
      }
    }
  }
`;

export default FeeBasedTransferExternalDebitCardsQuery;
